<template>
  <div>
    <el-form :model="myForm" ref="editFormRef" :rules="rules" label-width="100px" size="small">
      <el-form-item label="奖池名称" prop="name">
        <el-input v-model="myForm.name" placeholder="请输入奖池名称"></el-input>
      </el-form-item>

      <el-form-item label="公司名称" prop="tenantName">
        <el-select v-model="myForm.tenantName" placeholder="请选择公司" :disabled="!!myForm.id">
          <el-option v-for="(item, index) in companyList" :key="index" :label="item.companyName" :value="item.companyCode"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item label="描述">
        <el-input :autosize="{ minRows: 3, maxRows: 6 }" type="textarea" v-model="myForm.description"></el-input>
      </el-form-item>

      <el-form-item label="玩法" prop="type">
        <el-select v-model="myForm.type" placeholder="请选择玩法">
          <el-option v-for="(item, index) in arr2" :key="index" :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>

      <el-form-item>
        <div class="btnDiv">
          <el-button @click="quXiaoClick">取 消</el-button>
          <el-button type="primary" @click="diaQueDingClick">确 定</el-button>
        </div>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
/* eslint-disable */
import uploadImg from '@/components/common/uploadImg/Index.vue'
import { makeForm } from '@/utils/tools.js'
export default {
  props: ['rowData'],
  components: { uploadImg },
  data() {
    return {
      myForm: {
        name: '', // 奖池名称
        tenantName: '', // 公司名称
        description: '', // 描述
        type: '', // 玩法
        id: '',
      },
      rules: {
        name: [
          { required: true, message: '请输入活动名称', trigger: 'blur' },
          { min: 2, max: 20, message: '长度在 2 到 20 个字符', trigger: 'blur' },
        ],
        tenantName: [{ required: true, message: '请选择活动区域', trigger: 'change' }],
      },
      companyList: [],
      arr2: [{ label: '盲盒', value: 1 }],
    }
  },
  created() {},
  mounted() {
    console.log('我来了')
    if (this.rowData) {
      makeForm(this.myForm, this.rowData)
    }
    console.log('this.myForm', this.myForm)
    // 获取公司列表
    this.getGongSiList()
  },
  methods: {
    // 获取公司列表
    async getGongSiList() {
      const res = await this.$API.gongSi.get()
      console.log('getGongSiList', res)
      let { status, data = [], msg = '' } = res
      if (status == 200) {
        this.companyList = data
      } else {
        this.$message.warning(msg)
      }
    },
    imgChage(item) {
      this.myForm[item.name] = item.url
    },
    // 确定
    async diaQueDingClick() {
      this.$refs.editFormRef.validate(async (valid) => {
        if (valid) {
          // 编辑
          if (this.rowData) {
            const res = await this.$API.jiangChi.update(this.myForm)
            if (res.status != 200) return this.$message.error(res.msg)
            this.$emit('diaQueDingClick')
          } else {
            const res = await this.$API.jiangChi.add(this.myForm)
            if (res.status != 200) return this.$message.error(res.msg)
            this.$emit('diaQueDingClick')
          }
        }
      })
    },
    // 取消
    quXiaoClick() {
      this.$emit('quXiaoClick')
    },
  },
  destroyed() {},
}
</script>
<style lang="scss" scoped>
.el-input {
  width: 200px;
}
.btnDiv {
  display: flex;
  justify-content: flex-end;
  margin-top: 20px;
}
</style>
